export enum BannerType {
  ChannelingPartner = 'channeling-partner',
  Doctor = 'doctor',
}
